/**
 * Class name prefix for @tvg/fuse components in dcx-templating.
 * Must match the prefix used in webpack postcss-prefixer for tvg-fuse.css.
 */
export const FUSE_CLASS_PREFIX = 'templating_';
